import React from 'react';
import './DataTable.css';

function DataTable({ companies, selectedRows, onSelectRow, onSelectAll, selectAllChecked, onSort, sortBy, sortOrder }) {
  if (companies.length === 0) {
    return (
      <div className="empty-state">
        <p>No companies found. Upload an Excel file to get started.</p>
      </div>
    );
  }

  const SortHeader = ({ label, column }) => {
    const isActive = sortBy === column;
    const arrow = isActive ? (sortOrder === 'ASC' ? ' ↑' : ' ↓') : '';
    
    return (
      <th onClick={() => onSort(column)} className={`sortable ${isActive ? 'active' : ''}`}>
        {label}
        {arrow}
      </th>
    );
  };

  return (
    <div className="data-table-container">
      <table className="data-table">
        <thead>
          <tr>
            <th>
              <input 
                type="checkbox" 
                checked={selectAllChecked}
                onChange={onSelectAll}
              />
            </th>
            <SortHeader label="Name" column="name" />
            <SortHeader label="Email" column="email" />
            <SortHeader label="Employer" column="employer" />
            <SortHeader label="Location" column="location" />
            <th>Phone</th>
          </tr>
        </thead>
        <tbody>
          {companies.map(company => (
            <tr key={company.id} className={selectedRows.has(company.id) ? 'selected' : ''}>
              <td>
                <input 
                  type="checkbox" 
                  checked={selectedRows.has(company.id)}
                  onChange={() => onSelectRow(company.id)}
                />
              </td>
              <td className="col-name">{company.name || '-'}</td>
              <td className="col-email">
                <a href={`mailto:${company.email}`}>{company.email || '-'}</a>
              </td>
              <td className="col-employer">{company.employer || '-'}</td>
              <td className="col-location">{company.location || '-'}</td>
              <td className="col-phone">{company.phone || '-'}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default DataTable;
